export default __webpack_public_path__ + "static/media/img (3).023de0f7.jpg";